import { Component, OnInit, Input } from '@angular/core';
import { ShareType } from '../../../model/interfaces/share-type';
import { ResourceService } from '../../../services/resource.service';
import { OrderService } from '../../../services/order.service';
import { Router } from '@angular/router';
import { NavBarService } from 'src/app/services';

@Component({
    selector: 'app-ticket-card',
    templateUrl: 'ticket-card.component.html',
    styleUrls: ['ticket-card.component.scss']
})
export class TicketCardComponent implements OnInit
{
    @Input('share-type')
    public shareType: ShareType;

    public name: string;
    public size: number;
    public topPrize: number;

    private router: Router;
    private navBarService: NavBarService;
    private readonly resourceService: ResourceService;
    private readonly orderService: OrderService;

    public constructor(
        resourceService: ResourceService,
        orderService: OrderService,
        router: Router,
        navBarService: NavBarService
    )
    {
        this.resourceService = resourceService;
        this.orderService = orderService;
        this.router = router;
        this.navBarService = navBarService;
    }

    public ngOnInit(): void
    {
        this.name = this.shareType.Name;
        this.size = this.shareType.Size;
        this.topPrize = parseInt(this.resourceService.getString(`global_share_type_top_prize_${this.name}`), 10);
    }

    public addShareTypeToOrder(): void
    {
        this.orderService.addShareTypeToOrder(this.shareType, 1);
        this.navBarService.showBasketFlag(true);
        this.router.navigateByUrl('/lodder-til-salg');
        this.navBarService.navbarClicked({ name: 'basket', route: '' });
    }
}
